import React from "react";
import { type NextPage } from "next";
import { Page } from "components/page";
import { StackedLogos } from "components/logos";
import { CdpHero, ComposableCdpTemplate } from "components/platform/composable-cdp";
import { getLandingPageProps, getPageMetaImage, type LandingPageProps } from "utils";

const ComposableCdp: NextPage<LandingPageProps> = ({
  page,
  announcementBanner,
  defaultLogos,
  defaultMobileLogos,
  customers,
  destinations,
}) => {
  return (
    <Page
      title={page.metaTitle}
      description={page.metaDescription}
      image={getPageMetaImage({ src: page.metaImageUrl, alt: page.metaTitle })}
      announcementBanner={announcementBanner}
      theme="dark"
      bgColor="new.green.950"
    >
      <CdpHero eyebrow={page.eyebrow} title={page.title} description={page.description} />

      <StackedLogos
        customers={defaultLogos}
        mobileCustomers={defaultMobileLogos}
        my={0}
        pt={{ base: "biggest", md: "huger" }}
      />

      <ComposableCdpTemplate destinations={destinations} customers={customers} />
    </Page>
  );
};

export const getStaticProps = getLandingPageProps("/platform/composable-cdp", {
  loadDefaultLogos: true,
  loadDefaultMobileLogos: true,
  loadDestinations: "all",
  loadCustomers: ["grammarly"],
});

export default ComposableCdp;
